import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Components
import Header from '../components/Header/Header';
import CourseDetail from '../components/CourseDetail/CourseDetailSimple';

// Data and hooks
import { getCourseById } from '../data/courses';
import { useSyllabusLoader } from '../hooks/useSyllabusLoader';

const CoursePage = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  
  const course = getCourseById(courseId);
  const { syllabusContent, loading, error } = useSyllabusLoader(course);




  if (!course) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-16">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <h3 className="text-lg font-medium text-red-800 mb-2">Course Not Found</h3>
            <p className="text-red-700 mb-4">The requested course could not be found.</p>
            <button 
              onClick={() => navigate('/')}
              className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
            >
              Return to Homepage
            </button>
          </div>
        </main>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-16">
          <div className="flex justify-center items-center min-h-[400px]">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
              <p className="text-gray-600">Loading course content...</p>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />


      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-16">
        <CourseDetail
          course={course}
          syllabusContent={syllabusContent}
          loading={loading}
          error={error}
        />
      </main>
    </div>
  );
};

export default CoursePage;